import BookmarkSvg from '@/assets/icons/bookmark.svg?react'
import {useAccountInformationValue} from '@/auth/hooks/useAccountInformation'
import {getBookmarkObserveQueryOptions} from '@/lib/bookmark/hooks/useBookmark'
import {useLocale} from '@/lib/locale/locale'
import {BookmarkRoute} from '@/routeRegistry'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

interface Props {
  className?: string
  svgClassName?: string
  onClick?: MemoizedCallback<() => void>
}

export default memo(function BookmarkLink(props: Props) {
  const [locale] = useLocale()
  const accountInformation = useAccountInformationValue()

  const {data} = useQuery(
    getBookmarkObserveQueryOptions(
      {
        locale,
        accountInformation,
      },
      {
        select: bookmark => bookmark.size,
      },
    ),
  )

  const count = data ?? 0

  return (
    <Link to={BookmarkRoute.fullPath} className={props.className} onClick={props.onClick}>
      <BookmarkSvg className={props.svgClassName} aria-hidden />
      Bookmarks
      <VisuallyHidden>{`(${count} items)`}</VisuallyHidden>
    </Link>
  )
})
